import React from "react";

// components
import Cookies from "universal-cookie";
import getLezioni from "../../services/getLezioni";
import getCorso from "../../services/getCorso";
import getChiusura from "../../services/getChiusura";
import getInsegnanti from "../../services/getInsegnanti";
import Utils from "../../utils/utils";
import moment from "moment";
import { Page, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import getPresenze from "../../services/getPresenze";
import WaitDialog from "../../widgets/WaitDialog";
import getInsegnantePrices from "../../services/getInsegnantePrices";
import getTariffeInsegnanti from "../../services/getTariffeInsegnanti";

export default class PdfFatturatoPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	async componentDidMount() {
		this.setState({ waitDialogVisible: true });
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });
		const currentCorso = cookies.get("currentCorso", { path: "/" });
		this.reportMonth = cookies.get("reportMonth", { path: "/" });
		this.reportYear = cookies.get("reportYear", { path: "/" });

		this.lezioni = await getLezioni(username, token);
		this.corso = await getCorso(username, token, currentCorso);
		this.chiusura = await getChiusura(username, token);
		this.insegnanti = await getInsegnanti(username, token);
		this.tariffe = await getTariffeInsegnanti(username, token);

		this.oreInsegnanti = {};
		this.oreInsegnantiOrarie = {};
		this.giornateInsegnanti = {};
		this.tariffeInsegnanti = {};

		this.insegnanti.forEach(i => {
			this.oreInsegnanti[i.id] = 0;
			this.oreInsegnantiOrarie[i.id] = 0;
			this.giornateInsegnanti[i.id] = 0;
		});

		this.tariffe.forEach(t => {
			this.tariffeInsegnanti[t.id] = {
				ora: t.costo_ora,
				giorno: t.costo_giorno,
			};
		});

		this.lezioni = this.lezioni.filter(l => {
			var ll = moment(l.data, "yyyy-MM-DD HH:mm:ss");
			if (ll.month() + 1 != this.reportMonth) return false;
			if (ll.year() != this.reportYear) return false;
			return true;
		});

		for (var l of this.lezioni) {
			var registro = await getPresenze(username, token, l.id);
			if (registro.length <= 0) continue;

			var durata = l.durata / 60;
			if (l.divisione_fatturato == 1) {
				var numInsegnanti = 1 + l.altri_insegnanti.split(";").length - 1;
				durata = durata / numInsegnanti;
			}

			this.oreInsegnanti[l.id_insegnante] = this.oreInsegnanti[l.id_insegnante] + durata;
			l.altri_insegnanti.split(";").forEach(id => {
				this.oreInsegnanti[id] = this.oreInsegnanti[id] + durata;
			});

			if (l.fattura_giornaliera === "1") {
				this.giornateInsegnanti[l.id_insegnante] += 1;
				l.altri_insegnanti.split(";").forEach(id => {
					this.giornateInsegnanti[id] += 1;
				});
			} else {
				this.oreInsegnantiOrarie[l.id_insegnante] += durata;
				l.altri_insegnanti.split(";").forEach(id => {
					this.oreInsegnantiOrarie[id] += durata;
				});
			}
		}

		this.setState({ waitDialogVisible: false });
	}

	render() {
		let timeNow = moment().format("yyyy-MM-DD HH:mm:ss");

		return (
			<div style={{ width: "100%", height: "100%" }} key={Math.random()}>
				<PDFViewer style={{ width: "100%", height: "100%" }}>
					<Document>
						<Page
							size="A4"
							orientation="landscape"
							style={{ paddingTop: 60, paddingBottom: 50, paddingLeft: 50, paddingRight: 50 }}
							wrap
						>
							<View style={{ marginTop: -60 }}>
								<Image
									style={{ position: "absolute", top: 30, left: 10, width: "10%", height: "auto" }}
									src={{
										uri: "/static/media/loghi/nero_trasparente.png",
										method: "GET",
										headers: {},
										body: "",
									}}
								/>
								<Text
									style={{
										position: "absolute",
										top: 30,
										right: 10,
										fontSize: 12,
										width: "100%",
										textAlign: "right",
										color: "#999999",
									}}
								>
									{timeNow}
								</Text>
								<Text
									style={{
										margin: 10,
										fontSize: 18,
										marginTop: 30,
										width: "100%",
										textAlign: "center",
									}}
								>
									Ore da fatturare
								</Text>
								<Text
									style={{
										margin: 10,
										fontSize: 10,
										width: "100%",
										marginTop: -10,
										textAlign: "center",
									}}
								>
									{Utils.getMonthName(this.reportMonth)} {this.reportYear}
								</Text>
								<View style={styles.page}>
									{this.insegnanti &&
										this.insegnanti.map(insegnante => {
											return (
												<View wrap={false}>
													<Text style={{ fontSize: 12, paddingTop: 10, paddingBottom: 2 }}>
														{insegnante.nome +
															" " +
															insegnante.cognome +
															"  =>  " +
															this.oreInsegnanti[insegnante.id] +
															" ore totali:"}
													</Text>
													<Text style={{ fontSize: 12, paddingTop: 2, paddingBottom: 10 }}>
														{this.tariffeInsegnanti[insegnante.id].ora &&
														this.tariffeInsegnanti[insegnante.id].giorno
															? this.oreInsegnantiOrarie[insegnante.id] +
															  " ore da fatturare (" +
															  this.tariffeInsegnanti[insegnante.id].ora *
																	this.oreInsegnantiOrarie[insegnante.id] +
															  " €) - " +
															  this.giornateInsegnanti[insegnante.id] +
															  " giornate da fatturare (" +
															  this.tariffeInsegnanti[insegnante.id].giorno *
																	this.giornateInsegnanti[insegnante.id] +
															  " €)"
															: ""}
													</Text>
													<View
														style={{ height: 1, width: "100%", backgroundColor: "#cccccc" }}
													></View>
												</View>
											);
										})}
								</View>
							</View>
						</Page>
					</Document>
				</PDFViewer>
				<WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index} />
			</div>
		);
	}
}

const styles = StyleSheet.create({
	row: {
		flexDirection: "row",
		border: "1 solid #000",
		width: "90%",
	},
	page: {
		flexDirection: "column",
		backgroundColor: "#E4E4E4",
		fontSize: 8,
		backgroundColor: "#ffffff",
		padding: 10,
	},
	section: {
		margin: 10,
		padding: 10,
		flexGrow: 1,
	},
	weekEndOrangeDay: {
		borderLeft: "1 solid #000",
		flexDirection: "column",
		padding: 2,
		width: "93%",
		backgroundColor: "#ffad18",
	},
	weekEndDay: {
		borderLeft: "1 solid #000",
		flexDirection: "column",
		padding: 2,
		width: "93%",
		backgroundColor: "#ff0000",
	},
	weekDay: {
		borderLeft: "1 solid #000",
		flexDirection: "column",
		padding: 2,
		width: "93%",
	},
});
